export default __webpack_public_path__ + "static/media/home.e51ea83b.svg";